"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExpandIcon = function ExpandIcon(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: (className || '') + '',
    focusable: false,
    height: "10",
    role: "presentation",
    viewBox: "0 0 16 10",
    width: "16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.1484 0.648437L15.8516 1.35156L8 9.20312L0.148438 1.35156L0.851563 0.648438L8 7.79687L15.1484 0.648437Z"
  }));
};

ExpandIcon.defaultProps = {
  className: undefined
};
ExpandIcon.propTypes = {
  className: _propTypes.default.string
};
var _default = ExpandIcon;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9Ub2FzdC9FeHBhbmRJY29uLmpzIl0sIm5hbWVzIjpbIkV4cGFuZEljb24iLCJjbGFzc05hbWUiLCJkZWZhdWx0UHJvcHMiLCJ1bmRlZmluZWQiLCJwcm9wVHlwZXMiLCJQcm9wVHlwZXMiLCJzdHJpbmciXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7QUFDQTs7OztBQUVBLElBQU1BLFVBQVUsR0FBRyxTQUFiQSxVQUFhO0FBQUEsTUFBR0MsU0FBSCxRQUFHQSxTQUFIO0FBQUEsc0JBQ2pCO0FBQ0UsSUFBQSxTQUFTLEVBQUUsQ0FBQ0EsU0FBUyxJQUFJLEVBQWQsSUFBb0IsRUFEakM7QUFFRSxJQUFBLFNBQVMsRUFBRSxLQUZiO0FBR0UsSUFBQSxNQUFNLEVBQUMsSUFIVDtBQUlFLElBQUEsSUFBSSxFQUFDLGNBSlA7QUFLRSxJQUFBLE9BQU8sRUFBQyxXQUxWO0FBTUUsSUFBQSxLQUFLLEVBQUMsSUFOUjtBQU9FLElBQUEsS0FBSyxFQUFDO0FBUFIsa0JBU0U7QUFBTSxJQUFBLENBQUMsRUFBQztBQUFSLElBVEYsQ0FEaUI7QUFBQSxDQUFuQjs7QUFjQUQsVUFBVSxDQUFDRSxZQUFYLEdBQTBCO0FBQ3hCRCxFQUFBQSxTQUFTLEVBQUVFO0FBRGEsQ0FBMUI7QUFJQUgsVUFBVSxDQUFDSSxTQUFYLEdBQXVCO0FBQ3JCSCxFQUFBQSxTQUFTLEVBQUVJLG1CQUFVQztBQURBLENBQXZCO2VBSWVOLFUiLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuXG5jb25zdCBFeHBhbmRJY29uID0gKHsgY2xhc3NOYW1lIH0pID0+IChcbiAgPHN2Z1xuICAgIGNsYXNzTmFtZT17KGNsYXNzTmFtZSB8fCAnJykgKyAnJ31cbiAgICBmb2N1c2FibGU9e2ZhbHNlfVxuICAgIGhlaWdodD1cIjEwXCJcbiAgICByb2xlPVwicHJlc2VudGF0aW9uXCJcbiAgICB2aWV3Qm94PVwiMCAwIDE2IDEwXCJcbiAgICB3aWR0aD1cIjE2XCJcbiAgICB4bWxucz1cImh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnXCJcbiAgPlxuICAgIDxwYXRoIGQ9XCJNMTUuMTQ4NCAwLjY0ODQzN0wxNS44NTE2IDEuMzUxNTZMOCA5LjIwMzEyTDAuMTQ4NDM4IDEuMzUxNTZMMC44NTE1NjMgMC42NDg0MzhMOCA3Ljc5Njg3TDE1LjE0ODQgMC42NDg0MzdaXCIgLz5cbiAgPC9zdmc+XG4pO1xuXG5FeHBhbmRJY29uLmRlZmF1bHRQcm9wcyA9IHtcbiAgY2xhc3NOYW1lOiB1bmRlZmluZWRcbn07XG5cbkV4cGFuZEljb24ucHJvcFR5cGVzID0ge1xuICBjbGFzc05hbWU6IFByb3BUeXBlcy5zdHJpbmdcbn07XG5cbmV4cG9ydCBkZWZhdWx0IEV4cGFuZEljb247XG4iXX0=